import { select_options } from "./select_options";
import { convert_dd_mm_yy_to_Date } from "./util";

export const test_status_column_properties = {
  type: "singleSelect",
  valueOptions: [
    ...select_options.test_status,
    // { value: "P", label: "Pending" },
    // { value: "U", label: "Under Test" },
    // { value: "D", label: "Completed" },
    // { value: "N", label: "Not Required" },
  ],
};

export const date_column_properties = {
  type: "date",
  valueGetter: ({ value }) => {
    if (typeof value === "object") return value;
    return value && convert_dd_mm_yy_to_Date(value);
  },
};

export const reviewer_remark_status_column_properties = {
  type: "singleSelect",
  valueOptions: [
    // ...select_options.remark_status
    // { value: undefined, label: "Pending" },
    { value: "Pending", label: "Pending" },
    // { value: "Under Test", label: "Under Test" },
    // { value: "Completed", label: "Completed" },
    // { value: "Not Required", label: "Not Required" },
    { value: "Completed", label: "Completed" },
    { value: "Under Test", label: "Under Test" },
    { value: "OOS", label: "OOS" },
    { value: "OOT", label: "OOT" },
    { value: "Deviation", label: "Deviation" },
    { value: "Lab Event", label: "Lab Event" },
    { value: "QMS Impacted sample", label: "QMS Impacted sample" },
  ],
};
export const test_remark_status_column_properties = {
  type: "singleSelect",
  valueOptions: [
    // ...select_options.remark_status
    // { value: undefined, label: "Pending" },
    { value: "Pending", label: "Pending" },
    // { value: "Under Test", label: "Under Test" },
    // { value: "Completed", label: "Completed" },
    // { value: "Not Required", label: "Not Required" },
    { value: "Completed", label: "Completed" },
    { value: "Under Test", label: "Under Test" },
    { value: "OOS", label: "OOS" },
    { value: "OOT", label: "OOT" },
    { value: "Deviation", label: "Deviation" },
    { value: "Lab Event", label: "Lab Event" },
  ],
};

export const status_remark_status_column_properties = {
  type: "singleSelect",
  valueOptions: [
    // ...select_options.remark_status
    { value: undefined, label: "Pending" },
    { value: "Under Review", label: "Under Review" },
    { value: "Under Test", label: "Under Test" },
    // { value: "Not Required", label: "Not Required" },
    { value: "Awaiting Approval", label: "Awaiting Approval" },
    { value: "Under UD", label: "Under UD" },
    { value: "QC Testing Completed", label: "QC Testing Completed" },
    { value: "On Hold", label: "On Hold" },
  ],
};
